"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Metrics = void 0;
const validation_1 = require("../../validation");
/** @alpha */
var Metrics;
(function (Metrics) {
    Metrics.schema = {
        type: 'object',
        properties: {
            triangles: {
                type: 'number',
            },
            materials: {
                type: 'number',
            },
            textures: {
                type: 'number',
            },
            meshes: {
                type: 'number',
            },
            bodies: {
                type: 'number',
            },
            entities: {
                type: 'number',
            },
        },
        additionalProperties: false,
        required: ['triangles', 'materials', 'textures', 'meshes', 'bodies', 'entities'],
    };
    Metrics.validate = validation_1.generateValidator(Metrics.schema);
})(Metrics = exports.Metrics || (exports.Metrics = {}));
//# sourceMappingURL=metrics.js.map